export default __webpack_public_path__ + "static/media/Scenografia (2).6f7dbed5.jpg";